__turbopack_context__.v({
  "addressContainer": "LocSheet-module-scss-module__v5JtyW__addressContainer",
  "addressItem": "LocSheet-module-scss-module__v5JtyW__addressItem",
  "locListContainer": "LocSheet-module-scss-module__v5JtyW__locListContainer",
  "locSheet": "LocSheet-module-scss-module__v5JtyW__locSheet",
  "selected": "LocSheet-module-scss-module__v5JtyW__selected",
  "selectedLocContainer": "LocSheet-module-scss-module__v5JtyW__selectedLocContainer",
  "wrap": "LocSheet-module-scss-module__v5JtyW__wrap",
});
